// remove preloader
$(window).on('load', function() {
    setTimeout(function() {
        $('.preloader').removeClass('active');
    }, 500);
    setTimeout(function() {
        $('.preloader').remove();
    }, 1000);

});
// // animate height mobile
let prev;
$(window).on('load', function() {
    let primaryItems = document.querySelectorAll(".navbar__tablet #primary-menu > li");
    primaryItems.forEach((e)=> {
        e.addEventListener("click", (el)=> {

            // if( prev){
            //     console.log(123);
            //     let prevSubmenu = prev.querySelector(".sub-menu");
            //     let prevHeight = prevSubmenu.clientHeight;
            //     jQuery(prevSubmenu).height(prevHeight).animate({height: 0}, 200);
            //     jQuery(prevSubmenu).animate({opacity: 0}, 200);
            // }

            let submenu = e.querySelector(".sub-menu");

            let height = submenu.scrollHeight;
            console.log(height);
            el.style.maxHeight = 350;
            // if (!submenu.clientHeight > 0) {
                // jQuery(submenu).css('height', 'auto');
                // var autoHeight = jQuery(submenu).height();
                // jQuery(submenu).height(0).animate({height: autoHeight}, 200);
                // jQuery(submenu).animate({opacity: 1}, 200);
            // }
            // else {
            //     var autoHeight = jQuery(submenu).height();
            //     jQuery(submenu).height(autoHeight).animate({height: 0}, 200);
            //     jQuery(submenu).animate({opacity: 0}, 200);
            // }
            // prev = e;
            
        })
        

    })
    

});


jQuery.fn.animateAuto = function(prop, speed, callback){
    var elem, height, width;
    return this.each(function(i, el){
        el = jQuery(el), elem = el.clone().css({"height":"auto","width":"auto"}).appendTo("body");
        height = elem.css("height"),
        width = elem.css("width"),
        elem.remove();
        
        if(prop === "height")
            el.animate({"height":height}, speed, callback);
        else if(prop === "width")
            el.animate({"width":width}, speed, callback);  
        else if(prop === "both")
            el.animate({"width":width,"height":height}, speed, callback);
    });  
}

// init AOS
$(function(){
    let AOS = require('aos');
    AOS.init();
});

// animated buttons
$(function(){
    let animatedButton = $('.btn-animated');
    animatedButton.mouseover(function() {
        $(this).addClass('active');
    });

    animatedButton.mouseleave(function() {
        $(this).removeClass('active');
        $(this).addClass('in-active');
    });

    animatedButton.on("webkitAnimationEnd oanimationend msAnimationEnd animationend", onanimationend);

    let animatedWPButton = $('.wp-block-button__link');
    animatedWPButton.mouseover(function() {
        $(this).addClass('active');
    });

    animatedWPButton.mouseleave(function() {
        $(this).removeClass('active');
        $(this).addClass('in-active');
    });

    animatedWPButton.on("webkitAnimationEnd oanimationend msAnimationEnd animationend", onanimationend);

    function onanimationend() {
        $(this).removeClass('in-active');
    }
});

//  fancy inputs
$(function(){
    $('.fancy-input label').click(function() {
        $(this).parent().find('input').trigger( "focus" );
        $(this).parent().find('textarea').trigger( "focus" );
    });

    $('.fancy-input input').on('focus', function() {
        $(this).parents('.fancy-input').addClass('active');
    });

    $('.fancy-input input').on('focusout', function() {
        if ($(this).val() === '') {
            $(this).parents('.fancy-input').removeClass('active');
        }
    });

    $('.fancy-input textarea').on('focus', function() {
        $(this).parents('.fancy-input').addClass('active');
    });

    $('.fancy-input textarea').on('focusout', function() {
        if ($(this).val() === '') {
            $(this).parents('.fancy-input').removeClass('active');
        }
    });
});

//menu rwd
$(function(){
    let burger = $('.hamburger');

    if ( burger ) {
        burger.click(function() {
            $(this).toggleClass('is-active');
            let menu = $('.main-navigation');
            menu.toggleClass('opened');
        });
    }

    let menuElWithChildren = $('.main-navigation .menu .menu-item-has-children');

    menuElWithChildren.click(function() {
        if ($(window).width() < 1023) {
            if ($(this).hasClass('active')) {
                $('.main-navigation .menu .menu-item-has-children').removeClass('active');
            } else {
                $('.main-navigation .menu .menu-item-has-children').removeClass('active');
                $(this).addClass('active');
            }
        }
    });

    $( window ).resize(function() {
        if ($(window).width() >= 1023) {
            $('.main-navigation .menu .menu-item-has-children').removeClass('active');
        }
    });
});

//hide navbar on mobile if scroll
$(function(){
    let prevScrollpos = window.pageYOffset;
    let sideHeader = $('.site-header');

    $(window).scroll(function(){
        let currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            sideHeader.removeClass('scroll');
            sideHeader.addClass('in-scroll');
        } else {
            sideHeader.addClass('scroll');
            sideHeader.removeClass('in-scroll');
        }
        prevScrollpos = currentScrollPos;
    });
});

//accordin
$(function(){
    let accordinTrigger = $('.js-accordin-trigger');

    accordinTrigger.click(function() {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            $('.js-accordin-trigger').parent().removeClass('active');
            $(this).parent().addClass('active');
        }
    });
});

//scroll to support us if menu element clicked
$(function(){
    let menuItem = $('.menu .menu-item');

    menuItem.click(function(e) {
        var href = $(this).find('a').attr('href');
        if (href == "#wesprzyj-nas") {
             e.preventDefault();
            var paths = window.location.pathname.split('/');
            var path = '';

            if (paths[1] != '' && paths[1] == 'amazonki') {
                path = paths[1] + '/';
            } else {
                path = '';
            }

            window.location.href = '/' + path + href;

            setTimeout(function(){
                var hash = '.' + window.location.hash.replace('#', '');
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 120
                }, 1000, 'swing');
            }, 100);
        }
    });

    if(window.location.hash) {
        setTimeout(function(){
            var hash = '.' + window.location.hash.replace('#', '');
            $('html, body').animate({
            scrollTop: $(hash).offset().top - 120
            }, 1000, 'swing');
        }, 100);
    }
});

$(function(){
    function imageGallery() {
        $('.wp-block-gallery.color-box a, .gallery-list a').colorbox({
            rel:'gal',
            current: "obraz {current} z {total}",
            maxWidth: '90%',
            maxHeight: '90%',
        });
    }

    function enableColorBox() {
        if ($( window ).width() >= 760) {
            imageGallery();
        } else {
            $.colorbox.remove();
            $('.wp-block-gallery.color-box a').removeClass('cboxElement');
            $('.gallery-list a').removeClass('cboxElement');
        }
    }

    $('.wp-block-gallery.color-box a').click(function(e) {
        e.preventDefault();
    });

    $('.gallery-list a').click(function(e) {
        e.preventDefault();
    });

    enableColorBox()

    $(window).resize(function() {
        enableColorBox();
    });
});

$(function(){
    function tableFilter() {
        // Declare variables
        var table = document.getElementById("filterTable");
        if (table) {
            var input, filter, tr, td, i, txtValue, ammount, elInRow;
            input = document.getElementById("filterInput");
            filter = input.value.toUpperCase();
            tr = table.getElementsByTagName("tr");
            noResult = document.getElementById("noResult");
            ammount = 0;

            // Loop through all table rows, and hide those who don't match the search query
            for (i = 1; i < tr.length; i++) {
                elInRow = 0;
                for (j = 0; j < 3; j++) {
                    td = tr[i].getElementsByTagName("td")[j];
                    if (td) {
                        txtValue = td.textContent || td.innerText;
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {
                            elInRow++;
                        }
                    }
                }

                if (elInRow > 0) {
                    tr[i].style.display = "";
                    ammount++;
                } else {
                    tr[i].style.display = "none";
                }
            }

            if (ammount === 0) {
                noResult.style.display = "table-row";
            } else {
                noResult.style.display = "none";
            }
        }
    }

    $('.js-filter-btn').click(function(e) {
        tableFilter();
    });

    $(document).on('keypress',function(e) {
        if(e.which == 13) {
            tableFilter();
        }
    });
});

// lazy load images
document.addEventListener("DOMContentLoaded", function() {
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    let active = false;

    const lazyLoad = function() {
      if (active === false) {
        active = true;

        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.classList.remove("lazy");

              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });

              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
          });

          active = false;
        }, 50);
      }
    };

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("load", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
});


//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 3
// module chunks = 0